import { useVideoCallStore } from './videoCall.store'

export function videoStatusGet() {
  const store = useVideoCallStore()
  return store.videoStatus
}
